import * as React from 'react';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import Translate from '../../common/functions/translate';
import Dialog from '@material-ui/core/Dialog';
import TextField from "@material-ui/core/TextField";
import * as Modal from '../../common/components/modal/modalDialog';
import { createMuiTheme, MuiThemeProvider, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import Spinner from '../../common/components/spinner/spinner';
import Snackbar from "../../common/components/snackbar/snackbar";
import { ProductModel } from '../../models/product/productModel';
import { TabView, TabPanel } from 'primereact/tabview';
import CategoryService from '../../services/categoriesService';
import { CategoryModel } from '../../models/category/categoryModel';
import Button from "@material-ui/core/Button";
import ProductService from '../../services/productService';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CategoryDialog from '../../common/components/categoryDialog/categoryDialog';
import { faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';
import { DropdownModel } from '../../models/dropdownModel';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import { Units, ProductRelationTypes, CategoryType } from '../../common/enums';
import AddEditProductRelationComponent from './addEditProductRelationComponent';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import ProductChooseImageDialog from './productChooseImageDialog';
import { ProductImageModel } from '../../models/product/productImageModel';

interface IProps {
    closeAddEditProductModal: any,
    cancelClick: any,
    saveClick: any,
    isVisible: boolean,
    currentProduct: ProductModel,
}

interface IState {
    product: ProductModel;
    validationMessage: string,
    isLoading: boolean,
    activeIndex: number;
    selectedIndex: number;
    categories: Array<CategoryModel>;
    isVisibleAddEditCategoryDialog: boolean;
    isVisibleChooseImageDialog: boolean;
    isVisibleChooseImageDialogWrap: boolean;
    units: Array<DropdownModel>;
    categoryTypeId: number;
}

const theme = createMuiTheme({
    overrides: {
        MuiFormControl: {
            marginNormal: {
                marginTop: 5,
                marginBottom: 0,
                width: '100%',
            },
            root: {
                width: '100%',
            },
        },
        MuiFormControlLabel: {
            root: {
                marginLeft: '0px'
            }
        },
        MuiDialog: {
            paper: {
                margin: 0,
                maxWidth: '90% !important',
                minHeight: '92vh',
                maxHeight: '92vh',
            },
            paperFullWidth: {
                width: '65%'
            }
        },
    },
    palette: {
        primary: blue
    }
})

enum TabIndexes {
    ProductInfo = 0,
    InstallationActivities = 1,
    Fasteners = 2,
    NonExisting = 100
}

class ProductAddEditDialog extends React.Component<IProps, IState> {
    snackbar: any;
    categoryService = new CategoryService();
    productService = new ProductService();
    // eslint-disable-next-line
    priceRegExp = new RegExp("^([0-9]*\.?[0-9]{1,2})$");

    constructor(props: IProps) {
        super(props);

        this.state = {
            product: props.currentProduct,
            validationMessage: '',
            isLoading: false,
            activeIndex: TabIndexes.ProductInfo,
            selectedIndex: -1,
            categories: new Array<CategoryModel>(0),
            isVisibleAddEditCategoryDialog: false,
            isVisibleChooseImageDialog: false,
            isVisibleChooseImageDialogWrap: false,
            units: new Array<DropdownModel>(0),
            categoryTypeId: 0,
        };
    }

    componentDidMount() {
        var currentproduct = this.props.currentProduct;

        if (!currentproduct.productId) {
            currentproduct.isActive = true;
            this.setState({ product: currentproduct });
        }

        const units: Array<DropdownModel> = [];


        this.setState({
            isLoading: true,
            units: units.concat(HelperFunctions.enumToDropdownArray(Units, true))
        });

        if (!currentproduct.unitId) {
            currentproduct.unitId = Units.UnitNumber;
            this.setState({ product: currentproduct });
        }

        this.categoryService.getAllCategories().then(
            (data: any) => {
                this.setState({
                    isLoading: false,
                    categories: data,
                }, () => this.setCategoryType());
            })
            .catch(error => {
                this.snackbar.show({ severity: 'error', summary: error.message });
                this.setState({
                    isLoading: false
                });
            });
    }

    setCategoryType = () => {
        const { categories, product } = this.state;

        if (categories) {
            if (product.categoryId) {
                let selectedCategory = categories.find(c => c.id === product.categoryId);

                if (selectedCategory) {
                    this.setState({
                        categoryTypeId: selectedCategory.categoryTypeId
                    });
                }
            }
        }
    }

    handleChange = (key, value) => {
        if ((key === 'power' || key === 'secondPower' || key === 'priceFromSupplier' || key === 'diameter') && !value) {
            value = 0;
        }

        const product: ProductModel = { ...this.state.product };
        product[key] = value;
        this.setState({ product: { ...product } });
    };

    handleCheckboxChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name;

        const product: ProductModel = { ...this.state.product };
        product[name] = value;
        this.setState({
            product: { ...product }
        });
    }

    isProductFormIsValid = () => {
        let message = '';

        const { product } = this.state;

        if (!product.articleNumber) {
            message += Translate('Please add article number') + '<br />';
        }

        if (!product.article) {
            message += Translate('Please add article name') + '<br />';
        }

        if (!product.categoryId) {
            message += Translate('Please select category') + '<br />';
        }

        if (product.categoryId && this.state.categories.some(c => c.id === product.categoryId && c.parentId === null)) {
            message += Translate('Please select category') + '<br />';
        }

        // if (!product.brand) {
        //     message += Translate('Please add brand') + '<br />';
        // }

        if (product.articleNumber !== "ВОИ") {
            if (!product.price) {
                message += Translate('Please add price') + '<br />';
            } else {
                if (!product.price.toString().match(this.priceRegExp)) {
                    message += Translate('Product price is not valid') + '<br />';
                }
            }
        }

        if (!product.unitId) {
            message += Translate('Please select a unit') + '<br />';
        }

        if (product.relatedProducts) {
            for (let i = 0; i < product.relatedProducts.length; i++) {
                let relatedProduct = product.relatedProducts[i];
                if (!relatedProduct.count || relatedProduct.count === 0 || relatedProduct.count < 0) {
                    message += Translate('The quantity entered for the related article') + ' "' + relatedProduct.relatedProduct.article + '" ' + Translate('is not valid') + '!';
                }
            }
        }

        this.setState({
            validationMessage: message
        });

        return message === '';
    }

    handleSaveButton = (event) => {
        event.preventDefault();

        if (!this.isProductFormIsValid()) return;

        let product = { ...this.state.product };

        if (!product.discount) {
            product.discount = 0;
        }

        this.props.saveClick(product);
    };

    handleCancelButton = () => {
        this.props.cancelClick();
    }

    handleCancelDialogs = () => {
        this.showAddEditCategoryDialog(false);
        this.showProductChooseImageDialog(false);
    }

    showAddEditCategoryDialog = (show: boolean) => {
        this.setState({
            isVisibleAddEditCategoryDialog: show,
        });
    }

    showProductChooseImageDialog = (show: boolean) => {
        this.setState({
            isVisibleChooseImageDialogWrap: show,
        });
        setTimeout(() => this.setState({
            isVisibleChooseImageDialog: show
        }));
    }

    handleAddEditCategoryClick = (event) => {
        event.preventDefault();
        this.showAddEditCategoryDialog(true);
    }

    handleRemoveCategoryClick = (event) => {
        event.preventDefault();

        const product: ProductModel = { ...this.state.product };
        product.categoryId = undefined;
        this.setState({ product: { ...product } });
    }

    handleCategorySaveClick = (id: number) => {
        const product: ProductModel = { ...this.state.product };
        product.categoryId = id;
        this.setState({ product: { ...product } }, () => this.setCategoryType());
        this.showAddEditCategoryDialog(false);
    }

    returnCategoryLabel = (id, label) => {
        let category = this.state.categories.find(c => c.id === id);
        if (category) {

            if (label)
                label = category.name + " / " + label;
            else
                label = category.name;

            label = this.returnCategoryLabel(category.parentId, label);
        }

        return label;
    }

    isCategoryActive = (id, isActive) => {
        let category = this.state.categories.find(c => c.id === id);
        if (category) {
            if (isActive)
                isActive = (category.isActive && isActive);
            else
                isActive = category.isActive;

            isActive = isActive && this.isCategoryActive(category.parentId, category.isActive);
        }

        return isActive;
    }

    getCategoryType = () => {
        const { product, categories } = this.state;
        let category = categories.find(c => c.id === product.categoryId);
        let categoryTypeId = 0;

        if (category) {
            if (category.categoryTypeId) {
                categoryTypeId = category.categoryTypeId
            } else {
                while ((categoryTypeId === 0) && (category!.parentId != null)) {
                    // eslint-disable-next-line
                    category = categories.find(c => c.id === category!.parentId);

                    if (category) {
                        categoryTypeId = category!.categoryTypeId === undefined ? 0 : category!.categoryTypeId;
                    } else {
                        categoryTypeId = 0;
                    }
                }
            }
        }

        return categoryTypeId;
    }

    onImageChoosen = (productImage: ProductImageModel) => {
        this.showProductChooseImageDialog(false);

        let { product } = this.state;

        product.productImage = productImage;
        product.fileId = productImage.fileId;

        this.setState({
            product
        });
    }

    handleRemoveImageClick = () => {
        let { product } = this.state;

        product.productImage = new ProductImageModel();
        product.fileId = 0;

        this.setState({
            product
        });
    }

    public render() {
        const { isLoading, product, isVisibleAddEditCategoryDialog, units, activeIndex, categoryTypeId, categories } = this.state;

        const originalCategoryType = this.getCategoryType();

        let categoryType = originalCategoryType;
        let categoriesToRoot = HelperFunctions.getAllTypesToRoot(product.categoryId, categories);

        if (categoryType === CategoryType.Packages) {
            if (activeIndex === 1) {
                categoryType = CategoryType.Devices
            }
        }

        if (categoryType === CategoryType.Services) {
            if (activeIndex === 3) {
                categoryType = CategoryType.Labor
            }
        }

        let header = '';
        if (!product.productId) {
            header = Translate('NewArticle');
        } else {
            header = `${Translate('EditArticle')} "${product.article}"`;
        }

        let categoryIcon: JSX.Element | undefined = undefined;
        let showCategorylabel = true;
        if (product.categoryId) {
            if (this.state.categories.some(c => c.id === product.categoryId && c.parentId === null)) {
                showCategorylabel = false;
            }
            else {
                categoryIcon =
                    <FontAwesomeIcon
                        icon={faCheck}
                        style={{ color: this.isCategoryActive(product.categoryId, true) ? '#2196f3' : '#9e9e9e', marginRight: "5px" }}
                    />;
            }
        }

        return (
            <MuiThemeProvider theme={theme}>
                {isVisibleAddEditCategoryDialog ? (
                    <CategoryDialog
                        isVisible={this.state.isVisibleAddEditCategoryDialog}
                        saveClick={this.handleCategorySaveClick}
                        cancelClick={this.handleCancelDialogs}
                        currentCategoryId={this.state.product.categoryId}
                        categories={this.state.categories}
                    />
                ) : null}

                <Dialog
                    open={this.props.isVisible}
                    onClose={this.handleCancelButton}
                    fullWidth
                    disableBackdropClick={true}
                >
                    <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{header}</Modal.DialogTitle>
                    <Modal.DialogContent>
                        {isLoading ? <Spinner /> : null}
                        <Snackbar ref={(el) => this.snackbar = el} />
                        {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
                        <div>
                            <TabView activeIndex={this.state.activeIndex} onTabChange={(e) => this.setState({ activeIndex: e.index })}>
                                <TabPanel header={Translate('Characteristics')}>
                                    <div style={{ minHeight: '400px' }}>
                                        <div style={{ width: '100%', display: 'flex', marginTop: 15, alignItems: 'flex-end' }}>
                                            <TextField
                                                autoFocus
                                                label={Translate('Category')}
                                                InputProps={{
                                                    readOnly: true,
                                                    startAdornment: categoryIcon
                                                }}
                                                value={showCategorylabel ? this.returnCategoryLabel(product.categoryId, '') : ''}
                                                onClick={(e) => this.handleAddEditCategoryClick(e)}
                                            />
                                            <div style={{ marginLeft: 5, cursor: "pointer" }} onClick={(e) => this.handleRemoveCategoryClick(e)}>
                                                <FontAwesomeIcon
                                                    icon={faTimes}
                                                    style={{ color: '#9e9e9e', fontSize: '1.5em' }}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15 }}>
                                            <div style={{ width: '50%' }}>
                                                <TextField
                                                    name="articleNumber"
                                                    type="text"
                                                    label={Translate("Article number")}
                                                    onChange={(e) => this.handleChange('articleNumber', e.target['value'])}
                                                    value={product && product.articleNumber ? product.articleNumber : ""}
                                                />
                                            </div>
                                            <div style={{ width: "50%", marginLeft: 10 }}>
                                                <FormControl>
                                                    <InputLabel htmlFor="unit-label">{Translate('Unit')}</InputLabel>
                                                    <Select
                                                        value={product.unitId ? product.unitId : ''}
                                                        onChange={(e) => this.handleChange('unitId', e.target.value)}
                                                        inputProps={{
                                                            id: 'unit-label'
                                                        }}
                                                    >
                                                        {
                                                            units.map(m => <MenuItem key={m.value + 'role'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>
                                        <div style={{ marginTop: 15, width: '100%' }}>
                                            <TextField
                                                name="article"
                                                type="text"
                                                multiline={true}
                                                label={Translate("Article")}
                                                onChange={(e) => this.handleChange('article', e.target['value'])}
                                                value={product && product.article ? product.article : ''}
                                            />
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15 }}>
                                            <div style={{ width: '50%' }}>
                                                <TextField
                                                    name="brand"
                                                    type="text"
                                                    label={Translate("Brand")}
                                                    onChange={(e) => this.handleChange('brand', e.target['value'])}
                                                    value={product && product.brand ? product.brand : ""}
                                                />
                                            </div>
                                            <div style={{ width: '25%', marginLeft: 10 }}>
                                                <CurrencyTextField
                                                    label={`${Translate("Power1")} (kW)`}
                                                    variant="standard"
                                                    value={product && product.power ? product.power : ''}
                                                    currencySymbol=""
                                                    minimumValue="0"
                                                    outputFormat="string"
                                                    decimalCharacter="."
                                                    decimalPlaces={3}
                                                    decimalPlacesShownOnBlur={3}
                                                    decimalPlacesShownOnFocus={3}
                                                    digitGroupSeparator=" "
                                                    onChange={(e, value) => this.handleChange('power', value)}
                                                    placeholder="0.0"
                                                    textAlign="left"
                                                />
                                            </div>
                                            <div style={{ width: '25%', marginLeft: 10 }}>
                                                <CurrencyTextField
                                                    label={`${Translate("Power2")} (kW)`}
                                                    variant="standard"
                                                    value={product && product.secondPower ? product.secondPower : ''}
                                                    currencySymbol=""
                                                    minimumValue="0"
                                                    outputFormat="string"
                                                    decimalCharacter="."
                                                    decimalPlaces={3}
                                                    decimalPlacesShownOnBlur={3}
                                                    decimalPlacesShownOnFocus={3}
                                                    digitGroupSeparator=" "
                                                    onChange={(e, value) => this.handleChange('secondPower', value)}
                                                    placeholder="0.0"
                                                    textAlign="left"
                                                />
                                                {/* <TextField
                                                    name="power"
                                                    type="number"
                                                    label={`${Translate("Power")} (kW)`}
                                                    onChange={(e) => this.handleChange('power', e.target['value'])}
                                                    value={product && product.power ? product.power : ''}
                                                /> */}
                                            </div>
                                            {/* <div style={{ width: '30%', marginLeft: 10 }}>
                                                <TextField
                                                    name="model"
                                                    type="text"
                                                    label={Translate("Model")}
                                                    onChange={(e) => this.handleChange('model', e.target['value'])}
                                                    value={product && product.model ? product.model : ""}
                                                />
                                            </div> */}
                                        </div>
                                        {categoryTypeId === CategoryType.Materials || categoryTypeId === CategoryType.Pipes
                                            ? <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15 }}>
                                                <div style={{ width: '50%' }}>
                                                    <CurrencyTextField
                                                        label={Translate("Diameter")}
                                                        variant="standard"
                                                        value={product && product.diameter ? product.diameter : ''}
                                                        currencySymbol=""
                                                        minimumValue="0"
                                                        outputFormat="string"
                                                        decimalCharacter="."
                                                        digitGroupSeparator=" "
                                                        onChange={(e, value) => this.handleChange('diameter', value)}
                                                        placeholder="0.00"
                                                        textAlign="left"
                                                    />
                                                </div>
                                            </div>
                                            : null}
                                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15 }}>
                                            <div style={{ width: '50%' }}>
                                                <TextField
                                                    name="supplier"
                                                    type="text"
                                                    multiline={true}
                                                    label={Translate("Supplier")}
                                                    onChange={(e) => this.handleChange('supplier', e.target['value'])}
                                                    value={product && product.supplier ? product.supplier : ''}
                                                />
                                            </div>
                                            <div style={{ width: '50%', marginLeft: 10 }}>
                                                <CurrencyTextField
                                                    label={Translate("Price from supplier")}
                                                    variant="standard"
                                                    value={product && product.priceFromSupplier ? product.priceFromSupplier : ''}
                                                    currencySymbol=""
                                                    minimumValue="0"
                                                    outputFormat="string"
                                                    decimalCharacter="."
                                                    digitGroupSeparator=" "
                                                    onChange={(e, value) => this.handleChange('priceFromSupplier', value)}
                                                    placeholder="0.00"
                                                    textAlign="left"
                                                />
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15 }}>
                                            <div style={{ width: '50%' }}>
                                                <CurrencyTextField
                                                    label={Translate("Price")}
                                                    variant="standard"
                                                    value={product && product.price ? product.price : ''}
                                                    currencySymbol=""
                                                    minimumValue="0"
                                                    outputFormat="string"
                                                    decimalCharacter="."
                                                    digitGroupSeparator=" "
                                                    onChange={(e, value) => this.handleChange('price', value)}
                                                    placeholder="0.00"
                                                    textAlign="left"
                                                    disabled={product.articleNumber === "ВОИ"}
                                                />
                                            </div>
                                            <div style={{ width: '50%', marginLeft: 10 }}>
                                                <TextField
                                                    name="discount"
                                                    type="number"
                                                    label={Translate("Discount")}
                                                    onChange={(e) => this.handleChange('discount', e.target['value'])}
                                                    value={product && product.discount ? product.discount : ''}
                                                />
                                            </div>
                                        </div>
                                        {/* <div style={{ marginTop: 15, width: '100%' }}>
                                            <TextField
                                                name="description"
                                                type="text"
                                                multiline={true}
                                                label={Translate("Description")}
                                                onChange={(e) => this.handleChange('description', e.target['value'])}
                                                value={product && product.description ? product.description : ''}
                                            />
                                        </div> */}
                                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: 20 }}>
                                            <div style={{ width: '50%' }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="isActive"
                                                            checked={product.isActive}
                                                            onChange={(e) => this.handleCheckboxChange(e)}
                                                            color="primary"
                                                        />
                                                    }
                                                    label={Translate("Active")}
                                                    style={{ marginLeft: -10 }}
                                                />
                                            </div>
                                            <div style={{ width: '50%', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                <div style={{ verticalAlign: 'middle' }}>
                                                    <span style={{ color: '#2196f3', cursor: 'pointer' }} onClick={() => this.showProductChooseImageDialog(true)}>
                                                        {Translate('Select graphical element')}
                                                    </span>
                                                </div>
                                                {product.productImage && product.productImage.fileId ?
                                                    <div style={{ marginLeft: 2, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                        <img src={`data:${product.productImage.contentType};base64,${product.productImage.content}`}
                                                            alt={product.productImage.name} style={{ width: 'auto', maxHeight: 80 }} />
                                                        <div style={{ cursor: 'pointer' }} onClick={this.handleRemoveImageClick}>
                                                            <FontAwesomeIcon
                                                                icon={faTimes}
                                                                style={{ color: '#9e9e9e', fontSize: '1.5em' }}
                                                            />
                                                        </div>
                                                    </div>
                                                    : null}
                                            </div>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel header={Translate('Installation activities')}
                                    headerStyle={{
                                        display: categoriesToRoot.some(r => r === CategoryType.Devices || r === CategoryType.Equipment || r === CategoryType.Packages
                                            || r === CategoryType.Radiators || r === CategoryType.TowelRails) ? '' : 'none'
                                    }} >
                                    <div style={{ minHeight: '400px' }}>
                                        <AddEditProductRelationComponent
                                            selectedCategoryTypeId={categoryType}
                                            productRelationType={ProductRelationTypes.InstallationActivity}
                                            currentProduct={product} />
                                    </div>
                                </TabPanel>
                                <TabPanel header={Translate('Fasteners')}
                                    headerStyle={{ display: categoryType === CategoryType.Services || originalCategoryType === CategoryType.Services ? '' : 'none' }} >
                                    <div style={{ minHeight: '400px' }}>
                                        <AddEditProductRelationComponent
                                            selectedCategoryTypeId={categoryType}
                                            productRelationType={ProductRelationTypes.Fastener}
                                            currentProduct={product} />
                                    </div>
                                </TabPanel>
                                <TabPanel header={Translate('Labor in service')}
                                    headerStyle={{ display: categoryType === CategoryType.Services || originalCategoryType === CategoryType.Services ? '' : 'none' }} >
                                    <div style={{ minHeight: '400px' }}>
                                        <AddEditProductRelationComponent
                                            selectedCategoryTypeId={categoryType}
                                            productRelationType={ProductRelationTypes.Labor}
                                            currentProduct={product} />
                                    </div>
                                </TabPanel>
                                <TabPanel header={Translate('Articles in package')}
                                    headerStyle={{ display: categoryType === CategoryType.Packages || originalCategoryType === CategoryType.Packages ? '' : 'none' }} >
                                    <div style={{ minHeight: '400px' }}>
                                        <AddEditProductRelationComponent
                                            selectedCategoryTypeId={categoryType}
                                            productRelationType={ProductRelationTypes.Package}
                                            currentProduct={product} />
                                    </div>
                                </TabPanel>
                                <TabPanel header={Translate('Articles in kit')}
                                    headerStyle={{ display: categoryType === CategoryType.Kits ? '' : 'none' }} >
                                    <div style={{ minHeight: '400px' }}>
                                        <AddEditProductRelationComponent
                                            selectedCategoryTypeId={categoryType}
                                            productRelationType={ProductRelationTypes.Kits}
                                            currentProduct={product} />
                                    </div>
                                </TabPanel>
                            </TabView>
                            {this.state.isVisibleChooseImageDialogWrap
                                ? <ProductChooseImageDialog
                                    cancelClick={this.handleCancelDialogs}
                                    isVisible={this.state.isVisibleChooseImageDialog}
                                    currentProduct={product}
                                    imageChoosen={this.onImageChoosen} />
                                : null}
                        </div>
                    </Modal.DialogContent>
                    <Modal.DialogActions>
                        <div>
                            <Button onClick={this.handleCancelButton} variant="contained" style={{ marginRight: 10 }}>
                                {Translate("Cancel")}
                            </Button>
                            <Button onClick={(e) => this.handleSaveButton(e)} color="primary" variant="contained"
                                disabled={categoryTypeId === CategoryType.Pipes && (!product.diameter || product.diameter <= 0)}>
                                {Translate("Save")}
                            </Button>
                        </div>
                    </Modal.DialogActions>
                </Dialog >
            </MuiThemeProvider>
        )
    }
}

export default ProductAddEditDialog;